import React from 'react'
import Modal from '../../components/common/Modal'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { useMutation } from '@tanstack/react-query'
import { handleDeleteRequest } from '../../utils/api-handler.util'
import { QueryKeys } from '../../utils/queryKeyGenerator'
import { showToaster } from '../../utils/show-toaster.util'
import { useNavigate } from 'react-router-dom'

const DeletePromotionModal = ({ isOpen, onClose, promotionId }) => {
  const navigate = useNavigate()
  const deleteMutation = useMutation({
    mutationFn: () => handleDeleteRequest(`/admin/promotions/${promotionId}`),
    onSuccess: () => {
      showToaster('success', 'Promotion deleted successfully')
      QueryKeys.adminListPromotions.invalidateAll()
      onClose()
      navigate('/admin/promotions')
    },
    onError: () => {
      showToaster('error', 'Failed to delete promotion')
    },
  })

  const handleDelete = () => {
    deleteMutation.mutate()
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="relative w-[726px] h-[452px] bg-background rounded-[8px] flex flex-col items-center justify-center">
        <div className="mb-6 flex items-center justify-center">
          <ExclamationTriangleIcon className="w-[164px] h-[164px] text-error-900" />
        </div>
        <h2 className="font-bold text-[19.2px] leading-[23px] capitalize text-black mb-2 text-center">
          Are You Sure To Delete
        </h2>
        <p className="font-normal text-[16px] leading-[19px] text-black/70 text-center mb-8 max-w-[429px]">
          Are you sure you want to delete this promotion? This action can be reversed later.
        </p>
        <div className="flex gap-8 mt-2">
          <button
            className="w-[264px] h-[55px] flex items-center justify-center bg-gradient-to-r from-error-700 to-error-800 shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-[10px] font-medium text-[18px] capitalize text-white hover:opacity-90 disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={handleDelete}
            disabled={deleteMutation.isLoading}
          >
            {deleteMutation.isLoading ? 'Deleting...' : 'Delete'}
          </button>
          <button
            className="w-[264px] h-[55px] flex items-center justify-center border border-danger shadow-[0px_4px_4px_rgba(0,0,0,0.25)] rounded-[10px] font-medium text-[18px] capitalize text-error-900 hover:bg-neutral-200-100 disabled:opacity-70 disabled:cursor-not-allowed"
            onClick={onClose}
            disabled={deleteMutation.isLoading}
          >
            Cancel
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default DeletePromotionModal
